export const H_MENU = [
  {
    title: "Black Quality",
    subTitle: "Dashboards, widgets",
    menu: [
      {
        title: "Dashboard",
        icon1: "home",
        menu: [
          {
            title: "Default",
            url: `${process.env.PUBLIC_URL}/dashboard/default`,
            type: "link",
          },
          {
            title: "Ecommerce",
            url: `${process.env.PUBLIC_URL}/dashboards/ecommerce`,
            type: "link",
          },
        ],
      },
      {
        title: "Widgets",
        icon1: "widget",
        menu: [
          {
            title: "General",
            url: `${process.env.PUBLIC_URL}/widgets/general-widget`,
            type: "link",
          },
          {
            title: "Chart",
            url: `${process.env.PUBLIC_URL}/widgets/chart-widget`,
            type: "link",
          },
        ],
      },
      {
        title: "Page Layout",
        icon1: "layout",
        menu: [
          {
            title: "Hide Nav Scroll",
            url: `${process.env.PUBLIC_URL}/page-layout/hide-nav-scroll`,
            type: "link",
          },
          {
            title: "Footer Dark",
            url: `${process.env.PUBLIC_URL}/page-layout/footer-dark`,
            type: "link",
          },

          {
            title: "Footer Fixed",
            url: `${process.env.PUBLIC_URL}/page-layout/footer-fixed`,
            type: "link",
          },
        ],
      },
    ],
  },
  {
    title: "Applications",
    subTitle: "Ready To Use Apps",
    menu: [
      {
        title: "Project",
        icon1: "project",
        menu: [
          {
            title: "Project List",
            url: `${process.env.PUBLIC_URL}/project/project-list`,
            type: "link",
          },
          {
            title: "Create New",
            url: `${process.env.PUBLIC_URL}/project/create-project`,
            type: "link",
          },
        ],
      },
      {
        title: "File Manager",
        icon1: "file",
        url: `${process.env.PUBLIC_URL}/file-manager`,
        type: "link",
      },
      {
        title: "Ecommerce",
        icon1: "ecommerce",
        menu: [
          {
            title: "Product",
            url: `${process.env.PUBLIC_URL}/ecommerce/product`,
            type: "link",
          },
          {
            title: "Product Page",
            url: `${process.env.PUBLIC_URL}/ecommerce/product-page`,
            type: "link",
          },
          {
            title: "Product List",
            url: `${process.env.PUBLIC_URL}/ecommerce/product-list`,
            type: "link",
          },
          {
            title: "Payment Details",
            url: `${process.env.PUBLIC_URL}/ecommerce/payment-details`,
            type: "link",
          },
          {
            title: "Order History",
            url: `${process.env.PUBLIC_URL}/ecommerce/order-history`,
            type: "link",
          },
          {
            title: "Invoice",
            url: `${process.env.PUBLIC_URL}/ecommerce/invoice`,
            type: "link",
          },
          {
            title: "Cart",
            url: `${process.env.PUBLIC_URL}/ecommerce/cart`,
            type: "link",
          },
          {
            title: "Wishlist",
            url: `${process.env.PUBLIC_URL}/ecommerce/wishlist`,
            type: "link",
          },
          {
            title: "Checkout",
            url: `${process.env.PUBLIC_URL}/ecommerce/checkout`,
            type: "link",
          },
          {
            title: "Pricing",
            url: `${process.env.PUBLIC_URL}/ecommerce/pricing`,
            type: "link",
          },
        ],
      },
      {
        title: "Email",
        icon1: "email",
        menu: [
          {
            title: "Email App",
            url: `${process.env.PUBLIC_URL}/email/email-app`,
            type: "link",
            bookmark: true,
          },
          {
            title: "Email Compose",
            url: `${process.env.PUBLIC_URL}/email/email-compose`,
            type: "link",
          },
        ],
      },
      {
        title: "Chat",
        icon1: "chat",
        menu: [
          {
            title: "Chat App",
            url: `${process.env.PUBLIC_URL}/chat/chat`,
            type: "link",
          },
          {
            title: "Video chat",
            url: `${process.env.PUBLIC_URL}/chat/chat-video`,
            type: "link",
          },
        ],
      },
      {
        title: "Users",
        icon1: "user",
        menu: [
          {
            title: "Users Profile",
            url: `${process.env.PUBLIC_URL}/users/user-profile`,
            type: "link",
          },
          {
            title: "Users Edit",
            url: `${process.env.PUBLIC_URL}/users/edit-profile`,
            type: "link",
          },
          {
            title: "Users Cards",
            url: `${process.env.PUBLIC_URL}/users/user-cards`,
            type: "link",
          },
        ],
      },
      {
        title: "Bookmarks",
        icon1: "bookmark",
        url: `${process.env.PUBLIC_URL}/bookmark`,
        type: "link",
      },
      {
        title: "Contacts",
        icon1: "contact",
        url: `${process.env.PUBLIC_URL}/contacts`,
        type: "link",
      },
      {
        title: "Tasks",
        icon1: "task",
        url: `${process.env.PUBLIC_URL}/task`,
        type: "link",
      },
      {
        title: "Calender",
        icon1: "calender",
        url: `${process.env.PUBLIC_URL}/calendar-basic`,
        type: "link",
      },
      {
        title: "Social App",
        icon1: "social",
        url: `${process.env.PUBLIC_URL}/social-app`,
        type: "link",
      },
      {
        title: "To-Do",
        icon1: "to-do",
        url: `${process.env.PUBLIC_URL}/to-do`,
        type: "link",
      },
      {
        title: "Search Result",
        icon1: "search",
        url: `${process.env.PUBLIC_URL}/search`,
        type: "link",
      },
    ],
  },
  {
    title: "Forms & Table",
    subTitle: "Ready To Use Froms & Tables",
    menu: [
      {
        title: "Form Controls",
        icon1: "form",
        menu: [
          {
            title: "Form Validation",
            url: `${process.env.PUBLIC_URL}/form-controls/form-validation`,
            bookmark: true,
            type: "link",
          },
          {
            title: "Base Inputs",
            url: `${process.env.PUBLIC_URL}/form-controls/base-input`,
            type: "link",
          },
          {
            title: "Checkbox & Radio",
            url: `${process.env.PUBLIC_URL}/form-controls/radio-checkbox-control`,
            type: "link",
          },
          {
            title: "Input Groups",
            url: `${process.env.PUBLIC_URL}/form-controls/input-group`,
            type: "link",
          },
          {
            title: "Mega Options",
            url: `${process.env.PUBLIC_URL}/form-controls/mega-options`,
            type: "link",
          },
        ],
      },
      {
        title: "Form Widgets",
        icon1: "knowledgebase",
        menu: [
          {
            title: "Datepicker",
            url: `${process.env.PUBLIC_URL}/forms/form-widgets/datepicker`,
            type: "link",
          },
          {
            title: "Touch Spin",
            url: `${process.env.PUBLIC_URL}/forms/form-widgets/touch-spin`,
            type: "link",
          },
          {
            title: "Switch",
            url: `${process.env.PUBLIC_URL}/forms/form-widgets/switch`,
            type: "link",
          },
          {
            title: "Typeahead",
            url: `${process.env.PUBLIC_URL}/forms/form-widgets/typeahead`,
            type: "link",
          },
          {
            title: "Clipboard",
            url: `${process.env.PUBLIC_URL}/forms/form-widgets/clipboard`,
            type: "link",
          },
        ],
      },
      {
        title: "Form Layout",
        icon1: "landing-page",
        menu: [
          {
            title: "Form Wizard 1",
            url: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-1`,
            type: "link",
          },
          {
            title: "Form Wizard 2",
            url: `${process.env.PUBLIC_URL}/forms/form-layout/form-wizard-2`,
            type: "link",
          },
          {
            title: "Two Factor",
            url: `${process.env.PUBLIC_URL}/forms/form-layout/two-factor`,
            type: "link",
          },
        ],
      },
      {
        title: "Bootstrap Tables",
        icon1: "table",
        menu: [
          {
            title: "Basic Tables",
            url: `${process.env.PUBLIC_URL}/form/bootstrap-tables/basic-table`,
            bookmark: true,
            type: "link",
          },
          {
            title: "Table Components",
            url: `${process.env.PUBLIC_URL}/form/bootstrap-tables/table-componants`,
            type: "link",
          },
        ],
      },
      {
        title: "Data Tables",
        icon1: "task",
        menu: [
          {
            title: "Basic Init",
            url: `${process.env.PUBLIC_URL}/form/data-tables/basic-init`,
            type: "link",
          },
          {
            title: "Advance Init",
            url: `${process.env.PUBLIC_URL}/form/data-tables/advance-init`,
            type: "link",
          },
          {
            title: "API",
            url: `${process.env.PUBLIC_URL}/form/data-tables/api`,
            type: "link",
          },
          {
            title: "Data Sources",
            url: `${process.env.PUBLIC_URL}/form/data-tables/data-sources`,
            type: "link",
          },
        ],
      },
    ],
  },
  {
    title: "Components",
    subTitle: "Ui Components & Elements",
    menu: [
      {
        title: "Ui Kits",
        icon1: "ui-kits",
        menu: [
          {
            title: "Typography",
            url: `${process.env.PUBLIC_URL}/ui-kits/typography`,
            type: "link",
          },
          {
            title: "Avatars",
            url: `${process.env.PUBLIC_URL}/ui-kits/avatars`,
            type: "link",
          },
          {
            title: "Helper Classes",
            url: `${process.env.PUBLIC_URL}/ui-kits/helper-classes`,
            type: "link",
          },
          {
            title: "Grid",
            url: `${process.env.PUBLIC_URL}/ui-kits/grid`,
            type: "link",
          },
          {
            title: "Tag & Pills",
            url: `${process.env.PUBLIC_URL}/ui-kits/tag-pills`,
            type: "link",
          },
          {
            title: "Progress",
            url: `${process.env.PUBLIC_URL}/ui-kits/progress-bar`,
            type: "link",
          },
          {
            title: "Modal",
            url: `${process.env.PUBLIC_URL}/ui-kits/modal-bar`,
            type: "link",
          },
          {
            title: "Alert",
            url: `${process.env.PUBLIC_URL}/ui-kits/alert`,
            type: "link",
          },
          {
            title: "Popover",
            url: `${process.env.PUBLIC_URL}/ui-kits/popover`,
            type: "link",
          },
          {
            title: "Tooltip",
            url: `${process.env.PUBLIC_URL}/ui-kits/tooltip`,
            type: "link",
          },
          {
            title: "Dropdown",
            url: `${process.env.PUBLIC_URL}/ui-kits/dropdown`,
            type: "link",
          },
          {
            title: "Accordion",
            url: `${process.env.PUBLIC_URL}/ui-kits/accordion`,
            type: "link",
          },
          {
            title: "Tabs",
            url: `${process.env.PUBLIC_URL}/ui-kits/tabs`,
            type: "link",
          },
          {
            title: "Lists",
            url: `${process.env.PUBLIC_URL}/ui-kits/lists`,
            type: "link",
          },
        ],
      },
      {
        title: "Bonus Ui",
        icon1: "bonus-kit",
        menu: [
          {
            title: "Scrollable",
            url: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`,
            type: "link",
          },
          {
            title: "Tree View",
            url: `${process.env.PUBLIC_URL}/bonus-ui/tree`,
            type: "link",
          },
          {
            title: "Toasts",
            url: `${process.env.PUBLIC_URL}/bonus-ui/toasts`,
            type: "link",
          },
          {
            title: "Rating",
            url: `${process.env.PUBLIC_URL}/bonus-ui/rating`,
            type: "link",
          },
          {
            title: "Dropzone",
            url: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`,
            type: "link",
          },
          {
            title: "Tour",
            url: `${process.env.PUBLIC_URL}/bonus-ui/tour`,
            type: "link",
          },
          {
            title: "SweetAlert 2",
            url: `${process.env.PUBLIC_URL}/bonus-ui/sweet-alert-2`,
            type: "link",
          },
          {
            title: "Carousel",
            url: `${process.env.PUBLIC_URL}/bonus-ui/carousel`,
            type: "link",
          },
          {
            title: "Ribbons",
            url: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`,
            type: "link",
          },
          {
            title: "Pagination",
            url: `${process.env.PUBLIC_URL}/bonus-ui/pagination`,
            type: "link",
          },
          {
            title: "Breadcrumb",
            url: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`,
            type: "link",
          },
          {
            title: "Range Slider",
            url: `${process.env.PUBLIC_URL}/bonus-ui/range-slider`,
            type: "link",
          },
          {
            title: "Image Cropper",
            url: `${process.env.PUBLIC_URL}/bonus-ui/image-cropper`,
            type: "link",
          },
          {
            title: "Basic Card",
            url: `${process.env.PUBLIC_URL}/bonus-ui/basic-card`,
            type: "link",
          },
          {
            title: "Creative Card",
            url: `${process.env.PUBLIC_URL}/bonus-ui/creative-card`,
            type: "link",
          },
          {
            title: "Timeline",
            url: `${process.env.PUBLIC_URL}/bonus-ui/timeline`,
            type: "link",
          },
        ],
      },
      {
        title: "Icons",
        icon1: "icons",
        menu: [
          {
            title: "Flag Icon",
            url: `${process.env.PUBLIC_URL}icons/flag-icon`,
            type: "link",
          },
          {
            title: "Fontawesome Icon",
            url: `${process.env.PUBLIC_URL}/icons/font-awesome`,
            type: "link",
          },
          {
            title: "Ico Icon",
            url: `${process.env.PUBLIC_URL}/icons/ico-icon`,
            type: "link",
          },
          {
            title: "Themify Icon",
            url: `${process.env.PUBLIC_URL}/icons/themify-icon`,
            type: "link",
          },
          {
            title: "Feather Icon",
            url: `${process.env.PUBLIC_URL}/icons/feather-icon`,
            type: "link",
          },
          {
            title: "Whether Icon",
            url: `${process.env.PUBLIC_URL}/icons/whether-icon`,
            type: "link",
          },
        ],
      },
      {
        title: "Buttons",
        icon1: "button",
        menu: [
          {
            title: "Default Style",
            url: `${process.env.PUBLIC_URL}/buttons/buttons`,
            type: "link",
          },
          {
            title: "Flate Style",
            url: `${process.env.PUBLIC_URL}/buttons/flate-style`,
            type: "link",
          },
          {
            title: "Edge Style",
            url: `${process.env.PUBLIC_URL}/buttons/edge-style`,
            type: "link",
          },
          {
            title: "Raised Style",
            url: `${process.env.PUBLIC_URL}/buttons/raised-style`,
            type: "link",
          },
          {
            title: "Button Group",
            url: `${process.env.PUBLIC_URL}/buttons/button-group`,
            type: "link",
          },
        ],
      },
      {
        title: "Charts",
        icon1: "charts",
        menu: [
          {
            title: "Apex Chart",
            url: `${process.env.PUBLIC_URL}/charts/chart-apex`,
            type: "link",
          },
          {
            title: "Google Chart",
            url: `${process.env.PUBLIC_URL}/charts/chart-google`,
            type: "link",
          },
          {
            title: "Chatjs Chart",
            url: `${process.env.PUBLIC_URL}/charts/chartjs`,
            type: "link",
          },
        ],
      },
    ],
  },
  {
    title: "Pages",
    subTitle: "All Neccesory Pages Added",
    menu: [
      {
        title: "Sample Page",
        icon1: "sample-page",
        url: `${process.env.PUBLIC_URL}/pages/sample-page`,
        type: "link",
      },

      {
        title: "Error Page",
        icon1: "landing-page",
        menu: [
          {
            title: "Error 400",
            url: `${process.env.PUBLIC_URL}/others/error-400`,
            type: "link",
          },
          {
            title: "Error 401",
            url: `${process.env.PUBLIC_URL}/others/error-401`,
            type: "link",
          },
          {
            title: "Error 403",
            url: `${process.env.PUBLIC_URL}/others/error-403`,
            type: "link",
          },
          {
            title: "Error 404",
            url: `${process.env.PUBLIC_URL}/others/error-404`,
            type: "link",
          },
          {
            title: "Error 500",
            url: `${process.env.PUBLIC_URL}/others/error-500`,
            type: "link",
          },
          {
            title: "Error 503",
            url: `${process.env.PUBLIC_URL}/others/error-503`,
            type: "link",
          },
        ],
      },
      {
        title: "Authentication",
        icon1: "board",
        menu: [
          {
            title: "Login Simple",
            url: `${process.env.PUBLIC_URL}/auth/login`,
            type: "link",
          },
          {
            title: "Login With Bg Image",
            url: `${process.env.PUBLIC_URL}/auth/login-bg-img`,
            type: "link",
          },
          {
            title: "Login With Image Two",
            url: `${process.env.PUBLIC_URL}/auth/login-bg-img2`,
            type: "link",
          },
          {
            title: "Login With Validation",
            url: `${process.env.PUBLIC_URL}/auth/login-bs-validation`,
            type: "link",
          },
          {
            title: "Login With Tooltip",
            url: `${process.env.PUBLIC_URL}/auth/login-bs-tt-validation`,
            type: "link",
          },
          {
            title: "Login With Sweetalert",
            url: `${process.env.PUBLIC_URL}/auth/login-sa-validation`,
            type: "link",
          },
          {
            title: "Register Simple",
            url: `${process.env.PUBLIC_URL}/auth/sign-up`,
            type: "link",
          },
          {
            title: "Register With Bg Image",
            url: `${process.env.PUBLIC_URL}/auth/sign-up-one`,
            type: "link",
          },
          {
            title: "Register With Image Two",
            url: `${process.env.PUBLIC_URL}/auth/sign-up-two`,
            type: "link",
          },
          {
            title: "Register Wizard",
            url: `${process.env.PUBLIC_URL}/auth/sign-up-wizard`,
            type: "link",
          },
          {
            title: "Unlock User",
            url: `${process.env.PUBLIC_URL}/auth/unlock`,
            type: "link",
          },
          {
            title: "Forget Password",
            url: `${process.env.PUBLIC_URL}/auth/forget-password`,
            type: "link",
          },
          {
            title: "Reset Password",
            url: `${process.env.PUBLIC_URL}/auth/reset-password`,
            type: "link",
          },
          {
            title: "Maintenance",
            url: `${process.env.PUBLIC_URL}/auth/maintenance`,
            type: "link",
          },
        ],
      },
      {
        title: "Coming Soon",
        icon1: "faq",
        menu: [
          {
            title: "Coming Simple",
            url: `${process.env.PUBLIC_URL}/coming-soon/coming-soon`,
            type: "link",
          },
          {
            title: "Coming with Bg video",
            url: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-video`,
            type: "link",
          },
          {
            title: "Coming with Bg Image",
            url: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-img`,
            type: "link",
          },
        ],
      },
    ],
  },
  {
    title: "Miscellaneous",
    subTitle: "Bouns Pages & Apps",
    menu: [
      {
        title: "Gallery",
        icon1: "gallery",
        menu: [
          {
            title: "Gallery Grid",
            url: `${process.env.PUBLIC_URL}/gallery/gallery`,
            type: "link",
          },
          {
            title: "Gallery Grid Desc",
            url: `${process.env.PUBLIC_URL}/gallery/gallery-with-description`,
            type: "link",
          },
          {
            title: "Masonry Gallery",
            url: `${process.env.PUBLIC_URL}/gallery/gallery-masonry`,
            type: "link",
          },
          {
            title: "Masonry With Desc",
            url: `${process.env.PUBLIC_URL}/gallery/masonry-gallery-with-disc`,
            type: "link",
          },
          {
            title: "Hover Effects",
            url: `${process.env.PUBLIC_URL}/gallery/gallery-hover`,
            type: "link",
          },
        ],
      },
      {
        title: "Blog",
        icon1: "blog",
        menu: [
          {
            title: "Blog Details",
            url: `${process.env.PUBLIC_URL}/blog/blog-detail`,
            type: "link",
          },
          {
            title: "Blog Single",
            url: `${process.env.PUBLIC_URL}/blog/blog-single`,
            type: "link",
          },
          {
            title: "Add Post",
            url: `${process.env.PUBLIC_URL}/blog/add-post`,
            type: "link",
          },
        ],
      },
      {
        title: "FAQ",
        icon1: "faq",
        url: `${process.env.PUBLIC_URL}/faq`,
        type: "link",
      },
      {
        title: "Job Search",
        icon1: "job-search",
        menu: [
          {
            title: "Cards View",
            url: `${process.env.PUBLIC_URL}/job-search/job-cards-view`,
            type: "link",
          },
          {
            title: "List View",
            url: `${process.env.PUBLIC_URL}/job-search/job-list-view`,
            type: "link",
          },
          {
            title: "Job Details",
            url: `${process.env.PUBLIC_URL}/job-search/job-details`,
            type: "link",
          },
          {
            title: "Apply",
            url: `${process.env.PUBLIC_URL}/job-search/job-apply`,
            type: "link",
          },
        ],
      },
      {
        title: "Learning",
        icon1: "learning",
        menu: [
          {
            title: "Learning List",
            url: `${process.env.PUBLIC_URL}/learning/learning-list-view`,
            type: "link",
          },
          {
            title: "Detailed Course",
            url: `${process.env.PUBLIC_URL}/learning/learning-detail`,
            type: "link",
          },
        ],
      },
      {
        title: "Maps",
        icon1: "maps",
        menu: [
          {
            title: "Google Map",
            url: `${process.env.PUBLIC_URL}/maps/google-map`,
            type: "link",
          },
          {
            title: "Leaflet Map",
            url: `${process.env.PUBLIC_URL}/maps/leaflet-map`,
            type: "link",
          },
        ],
      },
      {
        title: "Editors",
        icon1: "editors",
        menu: [
          {
            title: "CK Editor",
            url: `${process.env.PUBLIC_URL}/editors/ck-editor`,
          },
          {
            title: "MDE Editor",
            url: `${process.env.PUBLIC_URL}/editors/simple-MDE`,
            type: "link",
          },
          {
            title: "ACE Code Editor",
            url: `${process.env.PUBLIC_URL}/editors/acecode-editor`,
          },
        ],
      },
      {
        title: "Knowledgebase",
        icon1: "knowledgebase",
        url: `${process.env.PUBLIC_URL}/knowledgebase/knowledgebase`,
        type: "link",
      },
      {
        title: "Support Ticket",
        icon1: "support-tickets",
        url: `${process.env.PUBLIC_URL}/support-ticket`,
        type: "link",
      },
    ],
  },
];
